import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ children }) => {
  const { admin } = useContext(AuthContext);


  // Check if admin object exists and has valid role
  if (!admin || admin.role?.toLowerCase() !== "admin") {
    return <Navigate to="/login" replace />;
  }

  return children;
};
